import { VehicleType } from '@cobliteam/common-types';
import type { TFunction } from '@cobliteam/i18n';

import BoatIcon from '@cobliteam/ui-business/icons/vehicle-icons/boat/boat.svg?react';
import CarIcon from '@cobliteam/ui-business/icons/vehicle-icons/car/car.svg?react';
import ConveyorIcon from '@cobliteam/ui-business/icons/vehicle-icons/conveyor/conveyor.svg?react';
import ForkLiftIcon from '@cobliteam/ui-business/icons/vehicle-icons/fork-lift/fork-lift.svg?react';
import GpuApuIcon from '@cobliteam/ui-business/icons/vehicle-icons/gpu-apu/gpu-apu.svg?react';
import LadderIcon from '@cobliteam/ui-business/icons/vehicle-icons/ladder/ladder.svg?react';
import LoaderIcon from '@cobliteam/ui-business/icons/vehicle-icons/loader/loader.svg?react';
import MotorcycleIcon from '@cobliteam/ui-business/icons/vehicle-icons/motorcycle/motorcycle.svg?react';
import TractorIcon from '@cobliteam/ui-business/icons/vehicle-icons/tractor/tractor.svg?react';
import TruckIcon from '@cobliteam/ui-business/icons/vehicle-icons/truck/truck.svg?react';
import TugIcon from '@cobliteam/ui-business/icons/vehicle-icons/tug/tug.svg?react';
import VanIcon from '@cobliteam/ui-business/icons/vehicle-icons/van/van.svg?react';

const getSizeOptions = (t: TFunction) => [
  { value: t('status.small', { ns: 'vehicles' }), label: t('status.small', { ns: 'vehicles' }) },
  { value: t('status.medium', { ns: 'vehicles' }), label: t('status.medium', { ns: 'vehicles' }) },
  { value: t('status.large', { ns: 'vehicles' }), label: t('status.large', { ns: 'vehicles' }) },
];

const getFuelOptions = (t: TFunction) => [
  { value: t('status.gasoline', { ns: 'vehicles' }), label: t('status.gasoline', { ns: 'vehicles' }) },
  { value: t('status.ethanol', { ns: 'vehicles' }), label: t('status.ethanol', { ns: 'vehicles' }) },
  { value: t('status.diesel', { ns: 'vehicles' }), label: t('status.diesel', { ns: 'vehicles' }) },
  { value: t('status.gnv', { ns: 'vehicles' }), label: t('status.gnv', { ns: 'vehicles' }) },
];

const getVehicleIconOptions = (t: TFunction) => [
  // General
  {
    value: VehicleType.CAR,
    label: t('status.car', { ns: 'vehicles' }),
    EndIcon: <CarIcon className='h-10' />,
  },
  {
    value: VehicleType.VAN,
    label: t('status.van', { ns: 'vehicles' }),
    EndIcon: <VanIcon className='h-10' />,
  },
  {
    value: VehicleType.TRUCK,
    label: t('status.truck', { ns: 'vehicles' }),
    EndIcon: <TruckIcon className='h-10' />,
  },
  {
    value: VehicleType.MOTORCYCLE,
    label: t('status.motorcycle', { ns: 'vehicles' }),
    EndIcon: <MotorcycleIcon className='h-10' />,
  },

  // Airport
  {
    value: VehicleType.TRACTOR,
    label: t('status.tractor', { ns: 'vehicles' }),
    EndIcon: <TractorIcon className='h-10' />,
  },
  {
    value: VehicleType.TUG,
    label: t('status.tug', { ns: 'vehicles' }),
    EndIcon: <TugIcon className='h-10' />,
  },
  {
    value: VehicleType.LOADER,
    label: t('status.loader', { ns: 'vehicles' }),
    EndIcon: <LoaderIcon className='h-10' />,
  },
  {
    value: VehicleType.LADDER,
    label: t('status.ladder', { ns: 'vehicles' }),
    EndIcon: <LadderIcon className='h-10' />,
  },
  {
    value: VehicleType.GPU_APU,
    label: t('status.gpu_apu', { ns: 'vehicles' }),
    EndIcon: <GpuApuIcon className='h-10' />,
  },
  {
    value: VehicleType.CONVEYOR,
    label: t('status.conveyor', { ns: 'vehicles' }),
    EndIcon: <ConveyorIcon className='h-10' />,
  },
  {
    value: VehicleType.FORK_LIFT,
    label: t('status.fork_lift', { ns: 'vehicles' }),
    EndIcon: <ForkLiftIcon className='h-10' />,
  },

  // Water
  {
    value: VehicleType.BOAT,
    label: t('status.boat', { ns: 'vehicles' }),
    EndIcon: <BoatIcon className='h-10' />,
  },
];

export { getSizeOptions, getFuelOptions, getVehicleIconOptions };
